module.exports = __webpack_public_path__ + "img/icon-members-club.133cd040.png";